// react-hook-form rethrows a rejected onSubmit after recording the failed
// submit (the form stays dirty). Callers log it instead of leaving an
// unhandled rejection; showing the failure to the user is onSubmit's job.
export default function logSubmitError(error: unknown) {
  console.error('[Form] onSubmit failed', error);
}
